// Thread tagging (sc-11471, Lake Stevens R2-10): marking an email Responsive also
// marks the undecided replies below it in its thread. The server does the tagging;
// these helpers read the result for the documents list and the notice.
import type { CaseDocument } from '../../types';

// Select item value for "Undo thread tagging" on the source email's decision menu.
export const UNDO_THREAD = 'undo-thread';

export function isThreadTagged(doc: Pick<CaseDocument, 'review_decision_source'>): boolean {
  return doc.review_decision_source === 'thread';
}

export interface ThreadTagIndex {
  /** Document names by id, to name a reply's source email. */
  names: Map<string, string>;
  /** How many replies each source email has tagged. */
  counts: Map<string, number>;
}

export function threadTagIndex(documents: CaseDocument[]): ThreadTagIndex {
  const names = new Map<string, string>();
  const counts = new Map<string, number>();
  for (const d of documents) {
    names.set(d.id, d.name);
    if (isThreadTagged(d) && d.review_decision_source_id) {
      counts.set(d.review_decision_source_id, (counts.get(d.review_decision_source_id) ?? 0) + 1);
    }
  }
  return { names, counts };
}

const replies = (n: number) => `${n} ${n === 1 ? 'reply' : 'replies'}`;

/** The notice after a decision followed through the thread, or null when nothing did. */
export function threadNoticeText(updates: CaseDocument[]): string | null {
  const tagged = updates.filter((d) => d.review_decision === 'responsive' && isThreadTagged(d)).length;
  if (tagged) return `Also marked ${replies(tagged)} in this thread Responsive`;
  const cleared = updates.filter((d) => !d.review_decision).length;
  if (cleared) return `Also cleared ${replies(cleared)} tagged from this thread`;
  return null;
}

/** Tooltip on a reply's "from thread" marker. */
export function threadMarkerLabel(sourceName: string | undefined): string {
  return sourceName
    ? `Marked Responsive because "${sourceName}", above it in the thread, is Responsive`
    : 'Marked Responsive because an email above it in the thread is Responsive';
}
